import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Feature } from '..';

interface FeatureApiDto {
  id: number;
  name: string;
  damageCategoryFeatures: { damageCategoryId: number }[] | null;
}

@Injectable({ providedIn: 'root' })
export class FeatureService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}`;

  loadFeatures(): Observable<{ count: number; result: Feature[] }> {
    return this.http
      .get<{ count: number; result: FeatureApiDto[] }>(`${this.baseUrl}/features`)
      .pipe(
        map((response) => ({
          count: response.count,
          result: response.result.map((x) => ({
            id: x.id,
            name: x.name,
            damageCategoryIds: (x.damageCategoryFeatures ?? []).map(
              (d) => d.damageCategoryId
            ),
          })),
        }))
      );
  }
}
